import { Component } from 'react'
import { AnchorPlacement } from 'interfaces/navigation'
import TextButton from 'components/atoms/buttons/TextButton'
import { activateAnchorActionCreator } from 'actions/navigationActions'
import { connect, MapDispatchToPropsFunction } from 'react-redux'
import { highlightCategoryActionCreator, setFilterCategoryActionCreator } from 'actions/globalActions'
import { State } from 'interfaces/state'
import { getAnchorPage, isCategorizedPage } from 'helpers/pageHelpers'
import { isAllCategorySelectedSelector } from 'selectors/globalSelectors'
import { isMobileSelector } from 'selectors/viewportSelectors'
import { HighlightCategoryPageType, CategorizedPageType } from 'interfaces/pages'

type SeeAllCategoriesButtonStateProps = {
  shouldRender: boolean
}

type SeeAllCategoriesButtonDispatchProps = {
  resetHighlightedCategory: () => void
  resetFilteredCategory: () => void
  activateAnchor: () => void
}

type SeeAllCategoriesButtonOwnProps = {
  placement: AnchorPlacement
}

type SeeAllCategoriesButtonProps =
  & SeeAllCategoriesButtonStateProps
  & SeeAllCategoriesButtonDispatchProps
  & SeeAllCategoriesButtonOwnProps

class SeeAllCategoriesButtonComponent extends Component<SeeAllCategoriesButtonProps> {

  render () {
    if (!this.props.shouldRender) {
      return null
    }

    return (
      <TextButton
        size='regular'
        onClick={ this.handleButtonClick }
      >
        See all
      </TextButton>
    )
  }

  private handleButtonClick = () => {
    const {
      resetFilteredCategory,
      resetHighlightedCategory,
      activateAnchor,
    } = this.props

    resetFilteredCategory()
    resetHighlightedCategory()
    activateAnchor()
  }
}

const mapStateToProps = (state: State, ownProps: SeeAllCategoriesButtonOwnProps): SeeAllCategoriesButtonStateProps => {
  const type = getAnchorPage(ownProps.placement)
  return {
    shouldRender: Boolean(type && isCategorizedPage(type) && !isAllCategorySelectedSelector(state, { type }) && isMobileSelector(state)),
  }
}

const mapDispatchToProps: MapDispatchToPropsFunction<SeeAllCategoriesButtonDispatchProps, SeeAllCategoriesButtonOwnProps> = (dispatch, ownProps) => {
  const type = getAnchorPage(ownProps.placement) as CategorizedPageType

  return ({
    resetHighlightedCategory: () => dispatch(highlightCategoryActionCreator(type as HighlightCategoryPageType, null)),
    resetFilteredCategory: () => dispatch(setFilterCategoryActionCreator(type, 'all')),
    activateAnchor: () => dispatch(activateAnchorActionCreator(ownProps.placement)),
  })
}
const SeeAllCategoriesButton = connect(mapStateToProps, mapDispatchToProps)(SeeAllCategoriesButtonComponent)

export default SeeAllCategoriesButton
